import React, { useEffect } from 'react';
import { flowTypeLabel } from '../../../../config/flows';

const PLParticipation = ({ data, setData, setisOwnMarginSetupModalOpen, locked = false }) => {
    useEffect(() => {
        if (locked && data.pl !== 'No') setData({ ...data, pl: 'No', ownMargin: '' });
    }, [locked, data, setData]);

    return (
        <section className="rounded-2xl border border-slate-200 bg-white p-4 shadow-sm sm:p-5">
            <h2 className="text-base font-bold text-[#0a1445] sm:text-lg">
                Will the {flowTypeLabel(data?._type)} setup their own Margins?
                <span className="text-red-600"> *</span>
            </h2>

            <div className="mt-4 grid grid-cols-2 gap-3">
                {['Yes', 'No'].map(option => {
                    const selected = data.pl === option;
                    return (
                        <button
                            key={option}
                            type="button"
                            disabled={locked}
                            onClick={() => setData({ ...data, pl: option, ownMargin: option === 'No' ? '' : data.ownMargin })}
                            className={`h-11 rounded-xl border text-sm font-semibold transition-all disabled:cursor-not-allowed disabled:opacity-70 ${selected ? 'border-[#fb6635] bg-orange-50 text-[#211b4f] ring-1 ring-[#fb6635]' : 'border-slate-200 text-slate-600 hover:border-orange-200'}`}
                        >
                            {option}
                        </button>
                    );
                })}
            </div>

            {locked && (
                <p className="mt-3 rounded-lg bg-blue-50 px-3 py-2 text-xs text-blue-700">
                    Always No for a Rize for Realtor Team — please enter the margins below.
                </p>
            )}
            {data.pl === 'No' && (
                <div className="mt-4 flex items-center justify-between gap-3 border-t border-slate-100 pt-4">
                    <h2 className="text-sm font-semibold text-[#0a1445]">
                        Setup your own margins
                        <span className="text-red-600"> *</span>
                    </h2>
                    <button
                        type="button"
                        onClick={() => setisOwnMarginSetupModalOpen(true)}
                        className="inline-flex h-9 flex-none items-center justify-center rounded-lg bg-[#211b4f] px-3 text-sm font-semibold text-white hover:bg-[#30266c]"
                        aria-label="Setup your own margins"
                    >
                        <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M5 12h14m-7 7V5" /></svg>
                    </button>
                </div>
            )}
        </section>
    );
};

export default PLParticipation;
